<template>
  <div>
    <label v-if="label" v-bind="labelBindings">{{ label }}</label>
    <textarea
        v-bind="inputBindings"
        :cols="cols"
        :rows="rows"
        v-on="inputEvents"
    ></textarea>
    <p v-if="invalid" class="text-danger">{{ errorMessage }}</p>
  </div>
</template>
<script>
import BaseInput from './BaseInput'

export default {
  extends: BaseInput,

  props: {
    cols: {
      type: Number,
      default: 30
    },
    rows: {
      type: Number,
      default: 10
    }
  }
}
</script>
